import { createSlice } from '@reduxjs/toolkit';

import initialState, * as handlers from './handlers';

const review = createSlice({
  name: 'review',
  initialState,
  reducers: {
    setReviewStateToStore: handlers.setReviewStateToStore,
  },
});

const { actions, reducer } = review;

export const { setReviewStateToStore } = actions;

export default reducer;
